export default {
        bind(el, binding) {
                const selectDropdown = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap');
                selectDropdown.addEventListener('scroll', function () {
                        const condition = this.scrollHeight - this.scrollTop <= this.clientHeight;
                        if (condition) {
                                binding.value();
                        }
                });
        },
};